var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "Edit "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"complaintName") || (depth0 != null ? lookupProperty(depth0,"complaintName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"complaintName","hash":{},"data":data,"loc":{"start":{"line":20,"column":45},"end":{"line":20,"column":62}}}) : helper)));
},"3":function(container,depth0,helpers,partials,data) {
    return "Edit Draft Complaint";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<h1 class=\"page-title\">"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isExtEdit") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":20,"column":23},"end":{"line":20,"column":97}}})) != null ? stack1 : "")
    + "</h1>\r\n<div class=\"breadcrumb-container\"></div>\r\n\r\n<div class=\"row m-b-md\">\r\n  <div class=\"col-lg-10 col-sm-12\">\r\n    <div class=\"edit-complaint-form\"></div>\r\n  </div>\r\n</div>";
},"useData":true});